import { PresetItemDTO } from '../ports/types';

export interface PresetDefinition {
  id: string;
  name: string;
  description: string;
  svgDataUri: string;
  thumbnailUri: string;
  width: number;
  height: number;
}

// 1. カスタードプリン (既定)
const PUDDING_SVG = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600">
  <defs>
    <radialGradient id="plateG" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="%23ffffff"/>
      <stop offset="85%" stop-color="%23e8e2d5"/>
      <stop offset="100%" stop-color="%23d0c6b6"/>
    </radialGradient>
    <linearGradient id="caramelG" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="%236e3519"/>
      <stop offset="100%" stop-color="%234a210d"/>
    </linearGradient>
    <linearGradient id="bodyG" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="%23ffeaa7"/>
      <stop offset="100%" stop-color="%23fdcb6e"/>
    </linearGradient>
    <filter id="shadow" x="-10%" y="-10%" width="120%" height="130%">
      <feDropShadow dx="0" dy="12" stdDeviation="15" flood-color="%23a08c7c" flood-opacity="0.35"/>
    </filter>
  </defs>
  <rect width="600" height="600" fill="%23fffaf2"/>
  <ellipse cx="300" cy="460" rx="240" ry="60" fill="url(%23plateG)" filter="url(%23shadow)"/>
  <ellipse cx="300" cy="455" rx="200" ry="45" fill="%23fdfcf9" stroke="%23dfd5c5" stroke-width="2"/>
  <path d="M 200,250 C 180,360 160,430 160,440 C 160,455 440,455 440,440 C 440,430 420,360 400,250 Z" fill="url(%23bodyG)"/>
  <path d="M 200,250 C 230,270 240,290 270,290 C 300,290 310,265 340,275 C 370,285 385,260 400,250 C 370,225 230,225 200,250 Z" fill="url(%23caramelG)"/>
  <ellipse cx="300" cy="245" rx="100" ry="25" fill="%23803c1b"/>
  <circle cx="270" cy="360" r="10" fill="%234a210d"/>
  <circle cx="330" cy="360" r="10" fill="%234a210d"/>
  <ellipse cx="250" cy="375" rx="12" ry="7" fill="%23ff7675" opacity="0.6"/>
  <ellipse cx="350" cy="375" rx="12" ry="7" fill="%23ff7675" opacity="0.6"/>
  <path d="M 292,375 Q 300,385 308,375" fill="none" stroke="%234a210d" stroke-width="4" stroke-linecap="round"/>
  <path d="M 300,230 C 320,180 340,165 370,160" fill="none" stroke="%2327ae60" stroke-width="5" stroke-linecap="round"/>
  <circle cx="300" cy="230" r="24" fill="%23d63031"/>
  <circle cx="293" cy="222" r="6" fill="%23ffffff" opacity="0.8"/>
  <ellipse cx="215" cy="340" rx="12" ry="40" fill="%23ffffff" opacity="0.45" transform="rotate(-15 215 340)"/>
</svg>`;

// 2. もも
const PEACH_SVG = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600">
  <defs>
    <radialGradient id="peachG" cx="45%" cy="40%" r="60%">
      <stop offset="0%" stop-color="%23ff9ebb"/>
      <stop offset="60%" stop-color="%23ff6b81"/>
      <stop offset="100%" stop-color="%23ee5253"/>
    </radialGradient>
  </defs>
  <rect width="600" height="600" fill="%23fff5f6"/>
  <ellipse cx="300" cy="510" rx="200" ry="30" fill="%23eddcd9"/>
  <path d="M 300,200 C 220,130 130,220 150,340 C 170,460 270,490 300,500 C 330,490 430,460 450,340 C 470,220 380,130 300,200 Z" fill="url(%23peachG)"/>
  <path d="M 300,200 Q 300,320 300,420" fill="none" stroke="%23c44155" stroke-width="4" stroke-linecap="round"/>
  <path d="M 300,190 C 270,120 220,130 200,150 C 230,180 270,180 300,190 Z" fill="%232ed573"/>
  <circle cx="250" cy="350" r="10" fill="%232f3542"/>
  <circle cx="350" cy="350" r="10" fill="%232f3542"/>
  <ellipse cx="230" cy="370" rx="14" ry="8" fill="%23ff4757" opacity="0.5"/>
  <ellipse cx="370" cy="370" rx="14" ry="8" fill="%23ff4757" opacity="0.5"/>
  <path d="M 292,365 Q 300,378 308,365" fill="none" stroke="%232f3542" stroke-width="4" stroke-linecap="round"/>
  <ellipse cx="200" cy="280" rx="20" ry="45" fill="%23ffffff" opacity="0.35" transform="rotate(-25 200 280)"/>
</svg>`;

// 3. ソーダゼリー
const JELLY_SVG = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600">
  <defs>
    <linearGradient id="jellyG" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="%2370a1ff"/>
      <stop offset="100%" stop-color="%231e90ff"/>
    </linearGradient>
  </defs>
  <rect width="600" height="600" fill="%23f1f6ff"/>
  <ellipse cx="300" cy="480" rx="210" ry="40" fill="%23d0e2ff"/>
  <path d="M 220,240 L 170,440 C 170,460 430,460 430,440 L 380,240 Z" fill="url(%23jellyG)" opacity="0.85"/>
  <ellipse cx="300" cy="240" rx="80" ry="25" fill="%23a4b0be" opacity="0.4"/>
  <circle cx="260" cy="350" r="10" fill="%23ffffff"/>
  <circle cx="340" cy="350" r="10" fill="%23ffffff"/>
  <path d="M 292,365 Q 300,375 308,365" fill="none" stroke="%23ffffff" stroke-width="4" stroke-linecap="round"/>
  <polygon points="300,200 305,215 320,215 308,225 312,240 300,230 288,240 292,225 280,215 295,215" fill="%23ffd32a"/>
</svg>`;

// 4. スライム
const SLIME_SVG = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600">
  <defs>
    <radialGradient id="slimeG" cx="45%" cy="40%" r="60%">
      <stop offset="0%" stop-color="%2355efc4"/>
      <stop offset="100%" stop-color="%2300b894"/>
    </radialGradient>
  </defs>
  <rect width="600" height="600" fill="%23e8f8f5"/>
  <ellipse cx="300" cy="490" rx="220" ry="35" fill="%23c2ece4"/>
  <path d="M 300,160 C 315,220 450,280 460,400 C 470,480 390,490 300,490 C 210,490 130,480 140,400 C 150,280 285,220 300,160 Z" fill="url(%23slimeG)"/>
  <circle cx="240" cy="370" r="14" fill="%232d3436"/>
  <circle cx="360" cy="370" r="14" fill="%232d3436"/>
  <circle cx="236" cy="365" r="4" fill="%23ffffff"/>
  <circle cx="356" cy="365" r="4" fill="%23ffffff"/>
  <ellipse cx="210" cy="395" rx="14" ry="7" fill="%2300cec9" opacity="0.6"/>
  <ellipse cx="390" cy="395" rx="14" ry="7" fill="%2300cec9" opacity="0.6"/>
  <path d="M 290,390 Q 300,405 310,390" fill="none" stroke="%232d3436" stroke-width="4" stroke-linecap="round"/>
  <ellipse cx="210" cy="270" rx="25" ry="50" fill="%23ffffff" opacity="0.4" transform="rotate(-30 210 270)"/>
</svg>`;

const PRESET_LIST: PresetDefinition[] = [
  {
    id: 'preset-pudding',
    name: 'カスタードプリン',
    description: 'つるんとしたカラメルと弾力感のあるカスタードプリン（既定アセット）',
    svgDataUri: PUDDING_SVG,
    thumbnailUri: PUDDING_SVG,
    width: 600,
    height: 600,
  },
  {
    id: 'preset-peach',
    name: 'もも',
    description: 'ピンク色のみずみずしい果実と柔らかなグラデーション',
    svgDataUri: PEACH_SVG,
    thumbnailUri: PEACH_SVG,
    width: 600,
    height: 600,
  },
  {
    id: 'preset-jelly',
    name: 'ソーダゼリー',
    description: '透き通るブルーと光沢感を持つプルプルゼリー',
    svgDataUri: JELLY_SVG,
    thumbnailUri: JELLY_SVG,
    width: 600,
    height: 600,
  },
  {
    id: 'preset-slime',
    name: 'スライム',
    description: 'ぷにぷにした不定形な弾性と大きなハイライトの水滴キャラ',
    svgDataUri: SLIME_SVG,
    thumbnailUri: SLIME_SVG,
    width: 600,
    height: 600,
  },
];

/**
 * プリセット画像カタログ＆プロバイダコンポーネント (PresetCatalogComponent)
 * 初回アクセス時・即時体験用の組み込みインラインSVGアセットの管理、
 * カタログ一覧の提供、およびID指定検索・安全なフォールバックを担う。
 */
export class PresetCatalog {
  private presets: Map<string, PresetDefinition> = new Map();

  constructor() {
    for (const preset of PRESET_LIST) {
      this.presets.set(preset.id, preset);
    }
  }

  /**
   * UI向けのプリセット一覧DTO配列を取得
   */
  public getPresetList(): PresetItemDTO[] {
    return PRESET_LIST.map((p) => ({
      id: p.id,
      name: p.name,
      thumbnailUri: p.thumbnailUri,
    }));
  }

  /**
   * プリセットIDから定義を取得（未知のIDは既定のプリンへ安全にフォールバック）
   */
  public getPresetById(id: string): PresetDefinition {
    const found = this.presets.get(id);
    if (found) {
      return found;
    }
    // 未知ID時は既定プリンを返却
    return this.getDefaultPreset();
  }

  /**
   * アプリ既定の初期プリセット（カスタードプリン）を取得
   */
  public getDefaultPreset(): PresetDefinition {
    return this.presets.get('preset-pudding')!;
  }
}
